import React, { useState, useEffect } from 'react'
import AdminDashboardComponents from "../../../components/HigherOrderComponents/AdminDashboardComponents";
import { deletethreeDCertifications, getAllthreeDCertifications, upsertthreeDCertification } from '../../../utils/actions/adminActions';
import { toast } from "react-toastify"
import useDocumentTitle from '../../../utils/useDocumentTitle';
import { Modal as AntdModal } from "antd";
import GenericLoaderComponent from '../../Loading/GenericLoaderComponent';

const ThreeDCertificationsComponent = () => {
    const token = localStorage.getItem("Token");
    useDocumentTitle('3D certifications');
    const [certifications, setCertifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({ id: "", name: "", price: 0, certificationType: "", review_required: false });
    const [isEditing, setIsEditing] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (form.review_required) {
            setForm((prevForm) => ({ ...prevForm, price: 0 }));
        }
    }, [form.review_required]);
    // console.log("Form Data :",form);


    useEffect(() => {
        (async () => {

            try {
                setLoading(true);
                const response = await getAllthreeDCertifications();
                if (!response || !response.success) {
                    toast.error("Data fetch failed. Please try again later");
                    return;
                }
                const { data } = response;
                setCertifications(data);

            } catch (error) {
                toast.error("Failed to fetch certifications");
            } finally {
                setLoading(false);
            }
        })()
    }, []);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prevForm) => ({ ...prevForm, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // console.log("Certification :", form);
            const response = await upsertthreeDCertification(form);
            if (!response || !response) {
                toast.error("Unable To create certifications at the moment");
                return;
            };
            const { data } = response;
            toast.success(`Certifications ${form._id ? "updated" : 'created'} succesfully`);
            resetForm();
            if (!form._id) {
                setCertifications((pre) => {
                    return [...pre, data];
                })
                return;
            }
            setCertifications((pre) => {
                return pre.map((item) => {
                    if (item._id == form._id) return data;
                    return item;
                })
            })


        } catch (error) {
            console.error("Error saving certification", error);
        }
    };

    const handleDelete = async (id) => {
        try {
            AntdModal.confirm({
                title: 'Confirm',
                content: 'Are you sure?',
                okText: 'Yes',
                cancelText: 'No',
                async onOk() {
                    const response = await deletethreeDCertifications(id);
                    console.log("Response :", response);
                    if (!response || !response.success) {
                        throw new Error();
                    }
                    toast.success('Deleted succesfully');
                    setCertifications((pre) => pre.filter((item) => item._id != id));
                },
                onCancel() {
                    console.log('Cancel');
                }
            });

        } catch (error) {
            toast.error("Data fetch failed. Please try again later");
        }
    }

    // Handle editing
    const handleEdit = (certification) => {
        setForm(certification);
        setIsEditing(true);
    };

    // Handle deletion


    // Reset the form
    const resetForm = () => {
        setForm({ id: "", name: "", price: "", certificationType: "", review_required: "" });
        setIsEditing(false);
    };

    return (
        <div className="p-6 w-full mx-auto bg-white shadow-lg rounded-md">
            <h1 className="text-2xl font-bold text-gray-800 mb-4 text-center">ThreeD Certification </h1>
            <GenericLoaderComponent
                isLoading={loading}
            />
            <form onSubmit={handleSubmit} className="mb-6 ">
                <input
                    type="text"
                    name="name"
                    placeholder="Certification Name"
                    value={form.name}
                    onChange={handleChange}
                    className="w-full my-2 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                    required
                />
                <input
                    type="number"
                    name="price"
                    disabled={form.review_required == 'true'}
                    placeholder="Price"
                    value={form.price}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*(\.\d{0,2})?$/.test(value)) {

                            handleChange(e)
                        }
                    }
                    }
                    className="w-full my-2 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                    required
                />
                <select
                    name="certificationType"
                    value={form.certificationType}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                    required
                >
                    <option value="">Select Certification Type</option>
                    <option value="per order">Per Order</option>
                    <option value="per line item">Per Line Item</option>
                </select>
                <select
                    name="review_required"
                    value={form.review_required}
                    onChange={handleChange}
                    className="w-full my-2 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                    required
                >
                    <option value="">Is Review Required</option>
                    <option value={false}>false</option>
                    <option value={true}>true</option>
                </select>
                <div className="flex space-x-4 my-2">
                    <button
                        type="submit"
                        className="px-4 py-2 bg-primaryColor text-white rounded-md hover:bg-primaryColor"
                    >
                        {isEditing ? "Update" : "Create"}
                    </button>
                    {isEditing && (
                        <button
                            type="button"
                            onClick={resetForm}
                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                        >
                            Cancel
                        </button>
                    )}
                </div>
            </form>

            <h2 className="text-xl font-semibold text-gray-700 mb-4">Certifications</h2>
            <table className="w-full table-auto border-collapse border border-gray-200">
                <thead>
                    <tr className="bg-gray-100">
                        <th className="border border-gray-300 px-4 py-2">Name</th>
                        <th className="border border-gray-300 px-4 py-2">Price</th>
                        <th className="border border-gray-300 px-4 py-2">Type</th>
                        <th className="border border-gray-300 px-4 py-2">Review Required</th>
                        <th className="border border-gray-300 px-4 py-2">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {certifications.map((certification) => (
                        <tr key={certification.id} className="text-center">
                            <td className="border border-gray-300 px-4 py-2 text-left">{certification.name}</td>
                            <td className="border border-gray-300 px-4 py-2">{certification.price}</td>
                            <td className="border border-gray-300 px-4 py-2">{certification.certificationType}</td>
                            <td className="border border-gray-300 px-4 py-2">{certification.review_required ? "true" : 'false'}</td>
                            <td className="border border-gray-300 px-4 py-2">
                                <div className="flex justify-center space-x-2">
                                    <button
                                        onClick={() => handleEdit(certification)}
                                        className="px-2 py-1 bg-green-500 text-white rounded-md hover:bg-green-600"
                                    >
                                        Edit
                                    </button>
                                    <button
                                        onClick={() => handleDelete(certification._id)}
                                        className="px-2 py-1 bg-red-500 text-white rounded-md hover:bg-red-600"
                                    >
                                        Delete
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default AdminDashboardComponents(ThreeDCertificationsComponent);